import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import moment, { Moment } from 'moment';
import { ToggleDrawerAction } from '../../state/actions';
import {
  MarketDrawerRootReducerState,
  getDealDate,
  getLiveState,
  getOpenState
} from '../../state/reducer';

@Component({
  selector: 'muni-gameday-market-drawer-header',
  templateUrl: './market-drawer-header.template.html',
  styleUrls: ['./market-drawer-header.styles.scss']
})
export class MarketDrawerHeaderComponent {
  public readonly live: Observable<boolean> = this.store.pipe(
    map(getLiveState)
  );
  public readonly date: Observable<Moment | undefined> = this.store.pipe(
    map(state => {
      const date = getDealDate(state);
      return date ? moment(date) : undefined;
    })
  );
  public readonly open: Observable<boolean> = this.store.pipe(
    map(getOpenState)
  );
  public readonly dealDateDefined: Observable<boolean> = this.store.pipe(
    map(state => !!getDealDate(state))
  );

  constructor(private store: Store<MarketDrawerRootReducerState>) {}

  public toggleDrawer(): void {
    this.store.dispatch(new ToggleDrawerAction());
  }
}
